<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando...</p>
    </div>
    <div class="main-content" v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Modelo</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="Name">
                      <span class="required">*</span> Nome do Modelo:
                    </label>
                    <input
                      autocomplete="new-password"
                      type="text"
                      id="Name"
                      class="form-control"
                      v-model="productModel.name"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>
                      <span class="required">*</span> Fabricante:
                    </label>
                    <v-select
                      v-model="productModel.manufacturer_id"
                      :options="manufacturers"
                      :reduce="(manufacturers) => manufacturers.id"
                      :label="'name'"
                    ></v-select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Fornecedor:</label>
                    <v-select
                      v-model="productModel.supplier_id"
                      :options="suppliers"
                      :reduce="(suppliers) => suppliers.id"
                      :label="'name'"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Status">
                      <span class="required">*</span> Status:
                    </label>
                    <select v-model="productModel.status" class="form-control">
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/product_models" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";

export default {
  name: "productModelAdd",
  data() {
    return {
      pageLoading: true,
      productModel: {
        name: "",
        manufacturer_id: "",
        supplier_id: "",
        status: "",
      },
      manufacturers: [],
      suppliers: [],
    };
  },
  components: {
    vSelect,
  },
  methods: {
    getManufacturers: function () {
      const self = this;
      const api = self.$store.state.api + "manufacturers/?status=1";

      return axios
        .get(api)
        .then((response) => {
          self.manufacturers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSuppliers: function () {
      const self = this;
      const api = self.$store.state.api + "suppliers/?status=1";

      return axios
        .get(api)
        .then((response) => {
          self.suppliers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "product_models";

      if (self.productModel.id) {
        api += "/" + self.productModel.id;
        self.productModel._method = "PUT";
      }

      axios
        .post(api, self.productModel)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/product_models");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProductModel: function (id) {
      const self = this;
      const api = self.$store.state.api + "product_models/" + id;

      return axios
        .get(api)
        .then((response) => {
          self.productModel = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  async mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.pageLoading = true;

    try {
      await Promise.all([self.getManufacturers(), self.getSuppliers()]);

      if (id) {
        await self.getProductModel(id);
      }
    } catch (e) {
      console.error(e);
    } finally {
      self.pageLoading = false;
    }
  },
};
</script>
